import * as React from "react";
import { BetBtn } from "../BetBtn";

export class BetBtnAmerican extends BetBtn {

    renderContent() {
        return (
            <div className="rj-ev-list__bet-btn__inner" data-uat="div-ev-list-bet-btn-inner">
                <div className={`rj-ev-list__bet-btn__row ${!this.shouldRenderText() && !this.shouldRenderPoints() ? "rj-ev-list__bet-btn__row--empty" : ""}`} data-uat="div-ev-list-bet-btn-row">
                    {this.renderText()}
                    {this.renderPoints()}
                </div>

                <div className={`rj-ev-list__bet-btn__row ${!this.shouldRenderOdds() ? "rj-ev-list__bet-btn__row--empty" : ""}`} data-uat="div-ev-list-bet-btn-row">
                    {this.renderOdds()}
                </div>
            </div>
        )
    }
}